import React, { useState, useEffect } from "react";
import littleGuy from "../../TDD-Images/little-guy-alone_2.png";
import { capitalizeFirstLetter, generateGUID, getPackName, hasMultipleQuestionPacks, hasPremSub, parseQuestionQuery } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { AssessmentInfo, companyOptions, JobDescription, Question, SessionQuestion, track, type, User } from '@/utils/types';
import buddy from '../../TDD-Images/buddysteppingstone.png'
import { useAppContext } from "../appContext";
import { createSvgIcon } from '@mui/material/utils';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { IconButton, TextField, Autocomplete, Chip, Stack, InputAdornment, Typography } from '@mui/material';
import UploadFile from './UploadFile';
import { DeviceHubOutlined, ElevatorOutlined, ErrorOutline, TaskAltOutlined } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { updateJobDescriptions, uploadUserResume, validatePreAssessmentLink } from '@/api';
import LoadingOverlay from './loadingOverlay';
import { BITESIZEDQuestions } from "@/utils/BiteSizedQuestions";
import { saveInfo } from "./signup";
import Nav from "./nav";
import { Button } from "@mui/material";
import { AxiosError } from 'axios';

const PreAssessment = () => {
  const [step, setStep] = useState(0); // Step 0 for not logged in
    const [initstep, setinitStep] = useState(-1); // Step 0 for not logged in
  const [checkboxes, setCheckboxes] = useState({
    shareProfile: false,
    declaration: false,
    terms: false,
  });
  const [assessmentDetails, setAssessmentDetails] = useState<AssessmentInfo | null>(null);
  const { auth0, state, reducers, startFunc } = useAppContext();
  const [resume, setResume] = useState<{ text: string; file: string }>({ text: "", file: "" });
  const [resumeError, setResumeError] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);
  const [navigateToAssessment, setNavigateToAssessment] = useState(false);
  const [navigateToPractice, setNavigateToPractice] = useState(false);
  const [startLoading, setStartLoading] = useState(false);

  useEffect(() => {
    // Check for step param in query string
    const params = new URLSearchParams(window.location.search);
    const stepParam = params.get("step");
    if (stepParam && !isNaN(Number(stepParam))) {
      setinitStep(Number(stepParam));
    }
    reducers.setisPractice(false);
  }, []);

  useEffect(() => {
    if (!state.authComplete) return; // Wait until auth is complete

    const fetchPreAssessmentInfo = async () => {
      const token = new URLSearchParams(window.location.search).get('candidate');
      if (token) {
        try {
          const assessmentDetails = await validatePreAssessmentLink(token, true);
          if (assessmentDetails) {
            if (assessmentDetails.authorized) {
              setAssessmentDetails(assessmentDetails);
              if (!state.profileUser) {
                setStep(0); // Not logged in
                return;
              }
              setStep(initstep > 0 ?initstep: 1);
            } else {
              setStep(-1); // No access
            }
          } else {
            setStep(-1); // Invalid token or no access
          }
        } catch (error) {
          if (error instanceof AxiosError && error.response?.status === 400) {
            console.error("Bad Request: ", error.response.data);
          } else {
            console.error("Unexpected error: ", error);
          }
          setStep(-1); // Handle error by showing no access
        }
      } else {
        setStep(-1); // No token provided
      }
    };

    fetchPreAssessmentInfo();
  }, [state.authComplete, state.profileUser, initstep]);

  useEffect(() => {
    if (navigateToAssessment) {
      const token = new URLSearchParams(window.location.search).get('candidate')||"";
      startFunc(0, true, token);
    }
  }, [navigateToAssessment]);

    useEffect(() => {
    if (navigateToPractice) {
      const token = new URLSearchParams(window.location.search).get('candidate')||"";
      startFunc(0, true, token);
    }
  }, [navigateToPractice]);

  const handleNext = () => setStep(step + 1);
  const handleBack = () => setStep(step - 1);

  const handlePracticeClick = () => {
     const token = new URLSearchParams(window.location.search).get('candidate')||"";
     let sesh: SessionQuestion[] = [];
        let sessionId = generateGUID();
        ["Reverse a string.", "Tell me about yourself."].forEach((q, ind) =>
          sesh.push({
            question: {
                                question: q,
                                level: null,
                                domain: "",
                                type: "",
                                specType: "",
                                subCategories: []
                              } as Question,
            feedback: "",
            actionsteps: "",
            prompt: [],
            fullprompt: [],
            samplesolution: "",
            code: "",
            useWhiteboard: false,
            codingLang: state.codingLang,
            time: 0,
            isHelpful: null,
            isHelpfulMessage: null,
            role: "",
            feedbackDuration: 0,
            sessionId: sessionId,
            videoid: `${token}_question${ind}`
          }));
          reducers.setsession(sesh);
          reducers.setshowVideo(true);
          reducers.setisPractice(true);
          setNavigateToPractice(true);
    } 

  const allChecked = Object.values(checkboxes).every((checked) => checked);

  const startInterview = async () => {
    if (state.profileUser) {
      const token = new URLSearchParams(window.location.search).get('candidate');
      if (token) {
        try {
          setStartLoading(true);
          validatePreAssessmentLink(token, false)
          .then((assessmentDetails) => {
            if (assessmentDetails && assessmentDetails.authorized) {
              let sesh: SessionQuestion[] = [];
              let sessionId = generateGUID();
              assessmentDetails.questions?.forEach((q, ind) =>
                sesh.push({
                  question: {
                                      question: q.question,
                                      level: null,
                                      domain: "",
                                      type: "",
                                      specType: "",
                                      subCategories: []
                                    } as Question,
                  feedback: "",
                  actionsteps: "",
                  prompt: [],
                  fullprompt: [],
                  samplesolution: "",
                  code: "",
                  useWhiteboard: false,
                  codingLang: state.codingLang,
                  time: 0,
                  isHelpful: null,
                  isHelpfulMessage: null,
                  role: "",
                  feedbackDuration: 0,
                  sessionId: sessionId,
                  videoid: `${token}_question${ind}`
                }));
                reducers.setsession(sesh);
                reducers.setisAssessment(true);
                reducers.setshowVideo(true);
                setNavigateToAssessment(true);
            } 
          else {
            setStep(-1); // No access
          }
          setStartLoading(false);
        })
      .catch((error) => {
          setStartLoading(false);
          setStep(-1); // No access
        });}
        catch (error) {
          console.error("Error starting interview: ", error);
          setStep(-1);
        }
      }
    }
  };
  const handleCheckboxChange = (id: keyof typeof checkboxes) => {
    setCheckboxes((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // Resume upload handler
  const handleResumeUpload = async () => {
    setResumeError(null);
    if (!resume.text || !resume.file) {
      setResumeError("Please upload your resume before continuing.");
      return;
    }
    setUploading(true);
    try {
      //await uploadUserResume(resume.text, resume.file);
      setStep(3);
    } catch (e) {
      setResumeError("Failed to upload resume. Please try again.");
    }
    setUploading(false);
  };

  if (!state.authComplete) {
    return <LoadingOverlay loadingOverlay={true} />;
  }

  return (
    <>
      <Nav />
      {(startLoading || !state.authComplete) && <LoadingOverlay loadingOverlay={true} />}
      <div className="full-nav flex flex-col items-center justify-center w-screen h-screen bg-gray-100">
        <div className="flex w-full h-full bg-white shadow-md rounded-lg overflow-hidden h-4/5">
          <div className="w-1/2 bg-blue-100 flex items-center justify-center">
            <Typography variant="h3" className="text-center text-gray-800 font-bold mb-4">
              {assessmentDetails?.companyName || "Assessment"}
            </Typography>
          </div>
          <div className="w-1/2 p-6 flex flex-col justify-center">
            {step === 0 && (
              <>
                <Typography variant="h4" className="text-center text-gray-800 font-bold mb-4">
                Welcome to the first step to your next job!
                </Typography>
                <Typography className="text-center text-gray-800 font-semibold mb-2">
                  Please Log In or Sign Up to the Dev Difference to access the assessment.
                </Typography>
                <div className="text-gray-700 text-sm space-y-4">
                  <p>Your account must match the email address the assessment was sent to.</p>
                </div>
                <div className="mt-6 flex justify-center">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#FFA726",
                      color: "white",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                    onClick={() => auth0.loginWithPopup()}
                  >
                    Log In / Sign Up
                  </Button>
                </div>
              </>
            )}
            {step === -1 && (
              <>
                <Typography variant="h4" className="text-center text-gray-800 font-bold mb-4">
                  {state.profileUser ? "Sorry, your account does not have access to this assessment." : "There is an issue with this assessment link."}
                </Typography>
                <Typography className="text-center text-gray-800 font-semibold mb-2">
                  Please contact info@thedevdifference.com if you believe this is an error.
                </Typography>
              </>
            )}
            {step === 1 && (
              <>
                <Typography variant="h4" className="text-center text-gray-800 font-bold mb-4">
                {assessmentDetails?.assessmentName || "Assessment"}
                </Typography>
                <Typography variant="h5" className="text-center text-gray-800 font-semibold mb-2">
                  What you can expect
                </Typography>
                <div className="text-gray-700 text-sm space-y-4">
                  <p>{`1. ${assessmentDetails?.timed ? "This is a timed 60-minute test.":""} Please make sure you are not interrupted during the test, as the timer cannot be paused once started.`}</p>
                  <p>2. Please ensure you have a stable internet connection.</p>
                  <p>3. We recommend that you try the sample test for a couple of minutes before taking the main test.</p>
                  <p>4. Your camera must remain fully accessible throughout the duration of the test.</p>
                  <p>5. Once the assessment is completed, the information is evaluated along with other application materials.</p>
                  <p>6. If you require an accommodation for a disability, submit a reasonable accommodation request.</p>
                </div>
                <div className="mt-6 align-self-end flex gap-4">
                  <Button
                  onClick={handlePracticeClick}
                    variant="outlined"
                    style={{
                      borderColor: "#FFA726",
                      color: "#FFA726",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                  >
                    Try Practice Test
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#FFA726",
                      color: "white",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                    onClick={handleNext}
                  >
                    Next
                  </Button>
                </div>
              </>
            )}
            {/* {step === 2 && (
              <>
                <Typography variant="h4" className="text-center text-gray-800 font-bold mb-4">
                  Upload Your Resume
                </Typography>
                <Typography className="text-center text-gray-800 font-semibold mb-2">
                  Please upload your resume to continue.
                </Typography>
                <div className="p-6 border border-[#D5D9EB] rounded-b-[8px] mb-4">
                  <UploadFile
                    handleDefaultRemove={() => setResume({ file: "", text: "" })}
                    
                    contentChange={() => setResume({ file: "", text: "" })}
                    handleFunc={(t: string, f: string, e?: string) => { setResume({ file: f, text: t }); }}
                  />
                  {resumeError && <Typography color="error" className="mt-2">{resumeError}</Typography>}
                </div>
                <div className="mt-6 flex justify-between">
                  <Button
                    variant="outlined"
                    style={{
                      borderColor: "#FFA726",
                      color: "#FFA726",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#FFA726",
                      color: "white",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                    onClick={handleResumeUpload}
                    disabled={uploading}
                  >
                    {uploading ? "Uploading..." : "Continue"}
                  </Button>
                </div>
              </>
            )} */}
            {step === 2 && (
              <>
                <Typography variant="h4" className="text-center text-gray-800 font-bold mb-4">
                  Confirmation Form
                </Typography>
                <div className="text-gray-700 text-sm space-y-4">
                  <p>Logged in as: <strong>{state.profileUser?.email}</strong></p>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="shareProfile"
                      checked={checkboxes.shareProfile}
                      onChange={() => handleCheckboxChange("shareProfile")}
                    />
                    <label htmlFor="shareProfile" className="ml-2" style={{ padding: 0 }}>
                      {`Share my profile with ${assessmentDetails!.companyName}`}
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="declaration"
                      checked={checkboxes.declaration}
                      onChange={() => handleCheckboxChange("declaration")}
                    />
                    <label htmlFor="declaration" className="ml-2" style={{ padding: 0 }}>
                      I will not consult/copy from any source including a website, book, or any individual to complete these tests...
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="terms"
                      checked={checkboxes.terms}
                      onChange={() => handleCheckboxChange("terms")}
                    />
                    <label htmlFor="terms" className="ml-2" style={{ padding: 0 }}>
                      I agree to The Dev Difference's Terms of Service and Privacy Policy
                    </label>
                  </div>
                </div>
                <div className="mt-6 flex justify-between">
                  <Button
                    variant="outlined"
                    style={{
                      borderColor: "#FFA726",
                      color: "#FFA726",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <Button
                  onClick={() => startInterview()}
                    variant="contained"
                    style={{
                      backgroundColor: allChecked ? "#4CAF50" : "#A5D6A7",
                      color: "white",
                      textTransform: "none",
                      padding: "10px 20px",
                    }}
                    disabled={!allChecked}
                  >
                    Agree & Start
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreAssessment;